import { useRecoilValue } from 'recoil';
import { currentDoseState, doseDataState } from '~/state/atoms/dose/doseAtoms';
import { OverlayLabel } from './OverlayLabel';

/**
 * Shows whether the dose currently rendered in the viewport is imported
 * from DICOM or AI-generated. Rendered inline inside the colorwash
 * overlay row above the Max/Normalized labels.
 */
const DoseOriginLabel = () => {
    const currentDose = useRecoilValue(currentDoseState);
    const doseData = useRecoilValue(doseDataState);

    if (!currentDose || !doseData) {
        return null;
    }

    const isAiGenerated = doseData.generated === true;

    return (
        <OverlayLabel data-testid="dose-origin-label">
            {isAiGenerated ? 'AI Generated Dose' : 'Imported Dose'}
        </OverlayLabel>
    );
};

export default DoseOriginLabel;
